<template>
  <div class="row">
    <el-dialog
      left
      title="Plan Change"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @open="open()"
      @close="handleCancel()"
      :visible.sync="value.isShow"
      style="margin: 0 auto"
      class="addCompanyModal col-lg-12 col-sm-12 col-12 col-md-12"
    >

        <div class>
          <label>Plan</label>
          <el-select
            class="todo-dropdown-el-select"
            size="large"
            placeholder="Select Plan"
            v-model="form.plan"
          >
            <el-option
              v-for="item in plansDropdown"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="form-group">
            <label>Workspaces</label>
            <div class="onefrtwo">
              <div  v-for="item in workspaceTypes" v-bind:key="item.name">
                  <input type="checkbox" v-model="form.workspaces" :id="item.name" :value="item._id">
                  <label class="form-check-label" :for="item.name">{{item.name}}</label>
              </div>
            </div>
        </div>

       
        <div class="col-xl edit-company-action-button-row" style="padding: 0px">
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancel"
          >
            Cancel
          </button>
          <button
            type="button"
            @click.prevent="writeToServer"
            class="todo-form-submit-button btn btn-primary"
          >
            Continue
            <!-- <i class="nc-icon nc-refresh-02 spinner" v-if="showSpinner"></i> -->
            <b-spinner
              v-if="showSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { Select, Option } from "element-ui";
import api from "../../../axios_api";
import config from "../../../../config/settings";
import {
  cbAdapter,
} from "../../../util";


export default {
  name: "dialog-plan-change",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
    },
  },
  data() {
    return {
      form: {
        plan: "",
        workspaces: []
      },
      showSpinner: false,
      workspaceTypes: [],
     plansDropdown: [
        {
          value: "free",
          label: "Free",
        },
        {
          value: "ap",
          label: "Ap",
        },
        {
          value: "pi",
          label: "Pi",
        },
      ],
    };
  },
  computed: {
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
        this.$emit("input", this.value);
      },
    },
  },
  watch: {
  },
  methods: {
    handleCancel() {
      this.isShow = false;
      this.form = {
        plan: "",
        workspaces: []
      };
    },
    async getPlan(){
      if(this.value.data.fiifiDetails){
        let accountPlan = await api.get(`/accountPlan/${this.value.data.fiifiDetails._id}`);
        if(accountPlan.data.encrypt.success){
          this.form.plan = accountPlan.data.encrypt.success.plan.name.toLowerCase();
        }
      }else{
        let accountPlan = await api.get(`/accountPlan/${this.value.data._id}`);
        if(accountPlan.data.encrypt.success){
          this.form.plan = accountPlan.data.encrypt.success.plan.name.toLowerCase();
        }
      }
    },
    async getWorkspaceTypes(){
      let res = await api.get("/workspaceTypes");
      this.workspaceTypes = res.data.encrypt.success;
    },
    async formWorkspaces(){
      if(this.value.data.fiifiDetails){
        if(this.value.data.fiifiDetails.workspaceTypes){
          this.form.workspaces = this.value.data.fiifiDetails.workspaceTypes;
        }
      }else{
        this.form.workspaces = this.value.data.workspaceTypes;
      }
    },
    async open(){
      await this.getPlan();
      await this.getWorkspaceTypes();
      await this.formWorkspaces();
    },
    async writeToServer(){
      try{
        this.showSpinner= true;
        if(!(this.value.data.fiifiDetails || this.value.data._id)) return;
      let data = await api.patch("/updatePlansAndWorkspaces", {
        ...this.form,
        account_id: this.value.data.fiifiDetails ? this.value.data.fiifiDetails._id : this.value.data._id
      })
      let refreshData = await api.get("/fiifi/users/analytics");
      await this.$emit("refresh", refreshData);
      }catch(err){
        console.log(err);
      }finally{
        this.showSpinner=false;
        this.handleCancel();
      }
    }
  },
};
</script>
<style lang="scss">
.addCompanyModal .el-dialog {
  padding-left: 20px;
  padding-right: 20px;
  min-height: 353px;
  width: 455px;
  max-width: 741px;
}

.addCompanyModal .el-dialog__title {
  line-height: 29px;
  font-size: 24px;
  color: #303133;
}
.addCompanyModal .el-dialog__header {
  padding-bottom: 0;
}

.addCompanyModal .el-dialog__footer {
  padding-left: 0;
  padding-right: 0;
  padding-top: 19px;
}

.addCompanyModal .el-dialog__body {
  min-height: 200px;
  padding-bottom: 0;
}

.style-2::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.style-2::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

.style-2::-webkit-scrollbar-thumb {
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}

.regular-checkbox:checked:after {
  content: "\2713";
  font-weight: bolder;
  font-size: 14px;
  position: absolute;
  top: 0px;
  left: 3px;
  color: #ffffff;
}

.regular-checkbox:active,
.regular-checkbox:checked:active {
  // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
  //   inset 0px 1px 3px rgba(0, 0, 0, 0.1);
}

.regular-checkbox:checked {
  background-color: #ff3f81;
  border: 1px solid #adb8c0;
  // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
  //   inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05),
  //   inset 15px 10px -12px rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.regular-checkbox {
  -webkit-appearance: none;
  background-color: #ffffff;
  border: 1px solid #707070;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 9px;
  border-radius: 3px;
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  // margin-top: 3px;
}

.AddCompanyLoader {
  border: 15px solid #f3f3f3;
  border-radius: 50%;
  border-top: 15px solid #3498db;
  width: 100px;
  height: 100px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.addCompanySearch::after {
  content: "\f002";
  font-size: 14px;
  font-weight: 900;
}

.addCompanySearchTitle {
  font-size: 14px;
  line-height: 17px;
  color: #000000cc;
}

.addCompanySearch {
  margin: 0 !important;
  border: 1px solid #868686 !important;
}

.addCompanyBadgesMainDiv {
  padding-left: 15px;
  padding-top: 10px;
  padding-right: 15px;
  flex-wrap: wrap;
}

.addCompanyBadgesLoopDiv {
  margin-right: 5px;
  background: #e8e7fb 0% 0% no-repeat padding-box;
  border: 1px solid #cdccfa;
  border-radius: 15px;
  opacity: 1;
  padding-top: 2px;
  padding-bottom: 3px;
  height: 25px;
  margin-bottom: 5px;
}

.addCompanyBadgesNameDiv {
  letter-spacing: 0px;
  color: #0000009a;
  opacity: 1;
  font-size: 12px;
  // line-height: 15px;
  padding-left: 12px;
  white-space: nowrap;
  overflow: hidden; /*width: 77px;*/
  text-overflow: ellipsis;
  padding-right: 5px;
}

.addCompanyBadgesCrossIconDiv {
  padding-right: 5px;
  font-size: 12px;
  // line-height: 15px;
  color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.addCompanyResultsDiv {
  padding-left: 15px;
  padding-bottom: 14px;
  letter-spacing: 0px;
  color: #00000083;
  text-transform: uppercase;
  opacity: 1;
  font-size: 12px;
  line-height: 18px;
  padding-top: 20px;
}

.addCompanyBodyLayoutDiv {
  max-height: 225px;
  overflow: auto;
  width: 374px;
}

.addCompanyBodyMainDiv {
  border-bottom: 1px solid #f4f4f4; /*padding-bottom: 5px;padding-top: 5px;*/
  margin-bottom: 13px;
}

.addCompanyBodyCheckBoxMainDiv {
  padding-right: 10px;
  padding-left: 4px;
  padding-top: 1.9px;
  padding-bottom: 11.9px;
}

.addCompanyBodyNameDiv {
  font-size: 14px; /*line-height: 28px;*/
  color: #000000cc;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-top: 3px;
  padding-bottom: 14px;
}

.addCompanyBodyAnywayDiv {
  letter-spacing: 0px;
  color: #000000;
  font-size: 14px;
  line-height: 24px;
  word-break: break-word;
}

.addCompanyBodyAnywaySpan {
  letter-spacing: 0px;
  color: #5445f3;
  text-decoration: underline;
  cursor: pointer;
}

.icon-container {
  position: absolute;
  right: 10px;
  top: calc(50% - 10px);
}
.searchloader {
  position: relative;
  height: 20px;
  width: 20px;
  display: inline-block;
  animation: around 5.4s infinite;
}

@keyframes around {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.searchloader::after,
.searchloader::before {
  content: "";
  //background: white;
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  border-width: 2px;
  border-color: #333 #333 transparent transparent;
  border-style: solid;
  border-radius: 20px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  animation: around 0.7s ease-in-out infinite;
}

.searchloader::after {
  animation: around 0.7s ease-in-out 0.1s infinite;
  //background: transparent;
}

.onefrtwo{
  display: grid;
  grid-template-columns: 1fr 1fr;
}

</style>
